import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-timer',
  standalone: true,
  styleUrls: ['./timer.component.css'],
  templateUrl: './timer.component.html',
})
export class TimerComponent implements OnDestroy {
  @Output() transactionExpired = new EventEmitter<boolean>();
  @Input() set createdTime(value) {
    if (!value) {
      return;
    }

    this._createdTime = value;
    this.timerObservable.subscribe(timer => {
      this.timer = timer;
    });
    this.setTimer();
    this.setTimerInterval();
  }

  get createdTime() {
    return this._createdTime;
  }

  get getTimer() {
    return this.timer;
  }

  private timerObservable = new Subject<string>();
  private interval: ReturnType<typeof setInterval>;
  private _createdTime: string | undefined;
  private isTimerOver = false;

  public timer: string;
  public transactionTimerLimit = 10;

  constructor() {}

  ngOnDestroy() {
    this.timerObservable.unsubscribe();
    clearInterval(this.interval);
  }

  setTimerInterval(): void {
    this.interval = setInterval(() => {
      this.setTimer();
    }, 1000);
  }

  setTimer(): void {
    if (!this.createdTime) {
      return;
    }

    const date = this.createdTime;
    const createdTime = new Date(date).getTime();
    const now = new Date().getTime();
    let diff =
      (this.transactionTimerLimit * 60000 - (now - createdTime)) / 1000;
    if (diff < 0) {
      diff = 0;
      if (!this.isTimerOver) {
        this.transactionExpiredModal();
        this.isTimerOver = true;
      }
    }
    const timeString = this.time2string(diff);
    this.timerObservable.next(timeString);
  }

  transactionExpiredModal() {
    this.transactionExpired.emit(true);
  }

  time2string(timeStamp: number): string {
    const days = Math.floor(timeStamp / 86400);
    timeStamp -= days * 86400;
    const hoursNum = Math.floor(timeStamp / 3600) % 24;
    const hours = (hoursNum < 10 ? '0' : '') + hoursNum;
    timeStamp -= hoursNum * 3600;
    const minutesNum = Math.floor(timeStamp / 60) % 60;
    const minutes = (minutesNum < 10 ? '0' : '') + minutesNum;
    timeStamp -= minutesNum * 60;
    const secondsNum = Math.floor(timeStamp % 60);
    const seconds = (secondsNum < 10 ? '0' : '') + secondsNum;
    return minutes + ':' + seconds;
  }
}
